import React from 'react';
import CKEditor from 'ckeditor4-react';

class TextEditor extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            html: props.value
        }

        this._handleChange = this._handleChange.bind(this);
    }

    _handleChange(e) {

        const { maxLength, onChange } = this.props;

        let html = e.editor.getData();

        if (html.length > maxLength) {

            html = html.substring(0, maxLength);
        }

        onChange({ html: html });

        this.setState({
            html: html
        });
    }

    render() {

        const { html } = this.state;
        const { disabled } = this.props;
        return (

            <CKEditor
                data={html}
                readOnly={disabled}
                onChange={this._handleChange}
                config={{
                    toolbar: [['Bold', 'Italic', 'Underline', 'Strike', 'Subscript', '-', 'RemoveFormat', '-',
                        'NumberedList', 'BulletedList', '-',
                        'Cut', 'Copy', 'Paste', '-', 'Undo', 'Redo', '-', 'Scayt', '-', 'Link', 'Unlink', '-', 'Image', 'Table', 'HorizontalRule', 'SpecialChar', '-', 'Maximize', '-', 'Source']
                    ],
                    allowedContent: true,
                    removeButtons: '',
                    forcePasteAsPlainText: true
                }}
            />
        );
    }
}

TextEditor.defaultProps = {
    maxLength: 3500,
    disabled: false
}

export default TextEditor;